import styled, { css } from "styled-components";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const FileInput = styled.input`
  width: 0;
  visibility: hidden;
  height: 0;
`;

export const FileInputLabel = styled.label`
  width: auto;
  color: #1bace4;
  font-family: "Lato";
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 1;
  text-align: center;
  text-align: left;
`;
export const FileInputLabelRequired = styled.label`
  width: auto;
  color: #1bace4;
  font-family: "Lato";
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 1;
  text-align: center;
  text-align: left;
  ::after {
    content: "*";
    color: #ea6457;
    font-weight: bold;
  }
`;

export const FileImageWrapper = styled.label`
  margin-top: 10px;
  border-radius: 40px;
  margin-left: 10px;
`;

export const DocumentRow = styled.div`
  margin-top: ${(props) => props.marginTop ?? "40px"};
`;

export const FileName = styled.p`
  line-height: 2;
  color: #084987;
  position: absolute;
  top: ${(props) => props.top ?? "-30px;"};
  position: relative;
  margin: 0;
  margin-bottom: 5px;
  font-family: "Lato";
  font-size: 14px;
`;

export const DeleteSpan = styled.span`
  border-radius: 40px;
  width: auto;
  margin-left: 7px;
`;

export const DocumentDropdown = styled.div`
  background: #fff;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  max-width: 10rem;
  padding: 10px 0;
  position: ${(props) => props.position ?? "absolute"}
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1),
    -webkit-transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 999;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  right: auto;
  left: auto;
  float: none;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: ${(props) => props.gridGap ?? "0px"};
  font-weight: normal;
  text-align: left;
`;
